import { Ban, TriangleAlertIcon } from 'lucide-react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tinct/web-components';

export type CancelGenerationModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isPending?: boolean;
  onConfirm: () => void;
};

/**
 * Confirmation before cancelling the campaign's pending generation. Only queued
 * jobs can be cancelled — a page already generating finishes — so the copy
 * says exactly what the user gets.
 */
export function CancelGenerationModal({
  open,
  onOpenChange,
  isPending,
  onConfirm,
}: CancelGenerationModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Cancel generation?</DialogTitle>
        </DialogHeader>
        <div className="flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3">
          <TriangleAlertIcon className="mt-0.5 size-4 shrink-0 text-amber-600" />
          <div className="flex flex-1 flex-col gap-1 text-sm text-amber-700">
            <span>
              Pages still queued go back to waiting; pages already generating
              will finish.
            </span>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Keep generating
          </Button>
          <Button variant="destructive" onClick={onConfirm} isLoading={isPending}>
            <Ban className="size-4" />
            Cancel generation
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
